module.exports = __webpack_public_path__ + "static/media/select.4b82ff03.svg";